import { render, staticRenderFns } from "./VideoCallMainScreen.vue?vue&type=template&id=cd92eaa2&scoped=true&"
import script from "./VideoCallMainScreen.vue?vue&type=script&lang=ts&"
export * from "./VideoCallMainScreen.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallMainScreen.vue?vue&type=style&index=0&id=cd92eaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd92eaa2",
  null
  
)

export default component.exports